import { StepManagerState } from '@/store/step-manager/state';
import { Mutations } from 'vuex-smart-module';
import { DealProgressStates } from '@/types/deal-progress';

export class StepManagerMutations extends Mutations<StepManagerState> {
	setLoading() {
		this.state.isLoading = true;
	}

	unsetLoading() {
		this.state.isLoading = false;
	}

	updateDealProgressStatus(stateProgress: DealProgressStates) {
		this.state.dealProgressStatus = stateProgress;
	}
}
